<template>
  <div>
    <PrimaryButton light @click.native="openDialog" shrink>
      Edit
      <v-icon class="ml-3">mdi-pencil</v-icon>
    </PrimaryButton>
    <EditCriminalConvictionsDialog
      :isOpen="isDialogOpen"
      @close="closeDialog"
      v-if="isDialogOpen"
    />
  </div>
</template>

<script>
import EditCriminalConvictionsDialog from "@/views/settings/components/dialogs/EditCriminalConvictionsDialog";
import PrimaryButton from "@/components/common/Button/PrimaryButton";

export default {
  name: "EditCriminalConvictionsAction",
  components: { PrimaryButton, EditCriminalConvictionsDialog },
  data() {
    return {
      isDialogOpen: false
    };
  },
  methods: {
    openDialog() {
      this.isDialogOpen = true;
    },
    closeDialog() {
      this.isDialogOpen = false;
    }
  }
};
</script>

<style scoped></style>
